var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "alert component",
      class: { "alert--fixed": _vm.isFixed, hidden: !_vm.visible },
      style: { backgroundColor: _vm.backgroundColor },
      attrs: { id: "alert-" + _vm.uuidv4() },
    },
    [
      _c(
        "div",
        {
          staticClass: "alert-wrapper",
          class: [_vm.isFixed ? "contained" : "container"],
        },
        [
          _c("div", {
            ref: "alertText",
            staticClass: "alert-text",
            style: { color: _vm.textColor === "black" ? "black" : "white" },
            domProps: { innerHTML: _vm._s(_vm.alertMessage) },
          }),
          _vm._v(" "),
          _vm.hasCloseIcon
            ? _c("span", {
                staticClass: "alert-icon",
                class:
                  _vm.textColor === "black"
                    ? "icon-close-black"
                    : "icon-close-white",
                attrs: { tabindex: "0", "aria-label": _vm.tc("booking.close") },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleCloseClick($event)
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.handleCloseClick($event)
                  },
                },
              })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }